import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import { fabric } from 'fabric'
import PropTypes from 'prop-types'
import * as _ from 'lodash'

import Palette from '../components/Palette'
import Button from '../components/Button'

import {
  CANVAS_SIZE, 
  CANVAS_SIZE_PORTRAIT_LAYOUT,
  CANVAS_SIZE_MAX_TABLET,
  MOBILE_WIDTH,
  MOBILE_WIDTH_LARGE,
  CONTAINER_MAX_WIDTH,
  TABLET_WIDTH_LARGE,
  DRAWING_CONTAINER_PADDING
  } 
  from '../constants'

class PromptCanvasContainer extends React.Component {
  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
        createHref: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }
  
  canvasObjectIds = []
  


  state = {
    selectedColor: null,
    brushWidth: 10,
    canvasSize: CANVAS_SIZE,
  }

  componentDidMount() {
    this.initializeCanvas()
    this.isSaved = false
    window.addEventListener('beforeunload', this.onWindowCloseHandler)
    window.addEventListener('resize', this.reSize )   
  }

  componentDidUpdate() {
    this.initializeCanvas()
  
  }

  componentWillUnmount() {
    this.onWindowCloseHandler();
    window.removeEventListener('resize', this.reSize );
  }

  onBrushStroke = async (newObj) => {
    /**
     * First we extract ONLY the properties of canvas objects that aren't constant.
     * The rest will be rehydrated upon reception from the firebase.
     *  */
    const latestCanvasObject = _.pick(newObj.path, ['height', 'left', 'stroke', 'strokeWidth', 'top', 'width', 'path'])
    const canvasObjectId = this.props.firebase
      .ref(`piccles/${this.props.piccleExperienceId}/${this.props.piccleKey}/objects`)
      .push(latestCanvasObject).key
    // store this key in a local class array for use in the UNDO method
    this.canvasObjectIds.push(canvasObjectId)
  }
  calcCanvasSize = ()=> {
    
    let screenWidth = window.innerWidth;
    let screenHeight = window.innerHeight;
    let aspectRatio = screenHeight/screenWidth;
    let canvasSize;
    if (screenWidth > MOBILE_WIDTH_LARGE && screenWidth < CONTAINER_MAX_WIDTH){
      canvasSize = screenWidth *0.85 - DRAWING_CONTAINER_PADDING*2 ;
    }
    else if ((screenWidth >= CONTAINER_MAX_WIDTH && screenWidth < TABLET_WIDTH_LARGE)||
    (screenWidth >= TABLET_WIDTH_LARGE &&  (aspectRatio < 1.6 && aspectRatio >= 1.3) )){
      canvasSize = CANVAS_SIZE_MAX_TABLET;
    }
    else if (screenWidth >= TABLET_WIDTH_LARGE){
      canvasSize = CANVAS_SIZE_PORTRAIT_LAYOUT
    } 
    else if (screenWidth < MOBILE_WIDTH){
      canvasSize = screenWidth *0.9;
    }
    else{
      canvasSize = CANVAS_SIZE;
    }
    return canvasSize;
  }


  initializeCanvas() {
    if (this.canvas || !this.props.drawing) {
      return
    }
     // set the initial canvas size
     let canvasSize = this.calcCanvasSize ();
     this.setState({ canvasSize });
     
    // Initialize the canvas element
    const canvas = new fabric.Canvas('prompt-canvas', {
      width: canvasSize,
      height: canvasSize,
      isDrawingMode: true,
    })
    this.canvas = window.canvas = canvas

    // Set some defaults on the canvas
    canvas.freeDrawingBrush.width = 10
    fabric.Object.prototype.transparentCorners = false
    this.colorSelected(this.props.drawing.colors[0])

    // setup callback to be triggered on every path creation event
    canvas.on('path:created', this.onBrushStroke)
    this.reSize();
    
  }
  // Canvas resize function
  reSize = () => {

    // resize the canvas as the window size changes
    let prevCanvasSize = this.state.canvasSize
    let canvasSize = this.calcCanvasSize()

    // calculate the difference between previous and new window size
    let delta =  canvasSize/ prevCanvasSize
    this.setState({ canvasSize });
    this.canvas.setHeight( canvasSize );
    this.canvas.setWidth( canvasSize );

    // set the zoom of the objects (brush strokes) to the same difference as the window size change

    this.canvas.setZoom(this.canvas.getZoom() * delta ) 

  };

  onWindowCloseHandler = () => {
    if (!this.isSaved) {
      this.deletePiccle()
    }
    this.canvas.dispose();
    window.removeEventListener('beforeunload', this.onWindowCloseHandler)
  }

  colorSelected = (color) => {
    this.setState({ selectedColor: color })
    this.canvas.freeDrawingBrush.color = color
  }

  isLoaded() {
    return this.props.drawing
  }

  setBrushWidth = (event) => {
    const width = parseInt(event.target.value, 10)
    this.canvas.freeDrawingBrush.width = width
    this.setState({ brushWidth: width })
  }

  deletePiccle = async () => {
    const { piccleExperienceId, piccleKey } = this.props

    await this.props.firebase
      .database()
      .ref(`piccles/${piccleExperienceId}/${piccleKey}`)
      .remove()
  }

  canvasIsColored() {
    const canvasJSON = this.canvas.toJSON()
    return canvasJSON && canvasJSON.objects && canvasJSON.objects.length > 0
  }

  finishDrawing = async () => {
    const { piccleExperienceId, piccleKey } = this.props

    if (!this.canvasIsColored()) {
      alert("You haven't drawn anything!")
      return
    }

    // add a complete status and finishTimestamp to the canvasSnapeshot
    await this.props.firebase.ref(`piccles/${piccleExperienceId}/${piccleKey}`).update({
      status: 'complete',
      finishTimestamp: new Date().valueOf(),
    })

    this.isSaved = true

    this.context.router.history.push(`/drawings/${piccleExperienceId}`)
  }

  undoDrawing = () => {
    const canvasObjectsCount = this.canvasObjectIds.length
    if (canvasObjectsCount > 0) {
      this.canvas.remove(this.canvas.item(canvasObjectsCount - 1))
      this.canvas.renderAll()
      this.props.firebase
        .ref(`piccles/${this.props.piccleExperienceId}/${this.props.piccleKey}/objects`)
        .child(this.canvasObjectIds.pop()) // here we pop the ID out of our local array as we pass it to firebase for removal
        .remove()
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const onlyUpdateOn = [
      // Only update if any of the following props have changed
      'auth',
      'piccleExperienceId',
      'piccleKey',
      'userId',
      'drawing',
      'piccle',
      'selectedColor',
      'brushWidth',
      'canvasSize'
    ].some((key) => nextProps[key] !== this.props[key] || nextState[key] !== this.state[key])
    return onlyUpdateOn
  }

  render() {
    const { drawing } = this.props
    const { brushWidth, canvasSize } = this.state

    if (!drawing) {
      return 'loading...'
    }

    return (
      <div className="container container--full">
        <h2 className="info-title hide-mobile">{drawing.prompt}</h2>
        <div className={this.isLoaded() ? 'drawing-container-fluid prompt-canvas-layout' : 'display-none'}>
          <div
            style={{
              width: canvasSize,
              height: canvasSize,
              boxShadow: '0 2px 12px 0 rgba(73,94,118,.25)',
              margin: 'auto',
            }}
          >
            <div>
              <canvas id="prompt-canvas" />
            </div>
          </div>
          <div className="instruments-container">
            <div className="palette-container">
              <Palette colors={drawing.colors} 
                       selectedColor={this.state.selectedColor} 
                       onSelect={this.colorSelected} 
                       />
            </div>
            <div className="range-container">
              <h5> Brush size:</h5>
              <input type="range" step={5} min={5} max={70} value={brushWidth} onChange={this.setBrushWidth} />
            </div>
            <div className="buttons-container">
              <Button type="reset" title="Undo" className="button-undo" onClickHandler={this.undoDrawing} />
              <Button type="submit" title="I'm Done" className="button-submit" onClickHandler={this.finishDrawing} />
            </div>
            <div className="info-box">
              <h2>{drawing.prompt}</h2>
            </div> 
          </div>
        </div>
        <div className="green-bg"></div>
      </div>
    )
  }
}

export default compose(
  firebaseConnect((props) => {
    return [
      `drawings/${props.match.params.piccleExperienceId}`,
      `piccles/${props.match.params.piccleExperienceId}/${props.match.params.piccleKey}`,
    ]
  }),
  connect((state, props) => {
    return {
      auth: state.firebase.auth,
      piccleExperienceId: props.match.params.piccleExperienceId,
      piccleKey: props.match.params.piccleKey,
      userId: state.firebase.auth.uid,
      drawing: _.get(state.firebase.data, `drawings.${props.match.params.piccleExperienceId}`),
      piccle: _.get(
        state.firebase.data,
        `piccles.${props.match.params.piccleExperienceId}.${props.match.params.piccleKey}`,
      ),
    }
  }),
)(PromptCanvasContainer)



// WEBPACK FOOTER //
// ./src/containers/promptCanvasContainer.js